export default __webpack_public_path__ + "static/media/KornyezetunkMegovasa.1850a929.jpg";